<template>
  <div class="alert-view">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less">
.alert-view {
  padding: 6px 12px;
  word-wrap: break-word;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
  border-radius: 4px;
  background-color: #fffbe6;
  border: 1px solid #ffe58f;

  .active {
    color: #faad14;
  }
}
</style>
